export const GET_ENTERPRISE_LIST_SUCCESS = 'GET_ENTERPRISE_LIST_SUCCESS';
export const GET_ENTERPRISE_LIST_FAIL = 'GET_ENTERPRISE_LIST_FAIL';
export const GET_ENTERPRISE_SUCCESS = 'GET_ENTERPRISE_SUCCESS';
export const GET_ENTERPRISE_FAIL = 'GET_ENTERPRISE_FAIL';
export const GET_ENTERPRISE_SEARCH_SUCCESS = 'GET_ENTERPRISE_SEARCH_SUCCESS';
export const GET_ENTERPRISE_SEARCH_FAIL = 'GET_ENTERPRISE_SEARCH_FAIL';
